<script lang="ts" setup>
import SingleSelect from '~/components/form-elements/SingleSelect.vue'
import AuthScope from '~/enums/auth-scope'
import type { AutocompleteItem, SelectedItem } from '~/types/form-elements'

const model = defineModel<SelectedItem | null>()

withDefaults(
  defineProps<{
    isRequired?: boolean
  }>(),
  { isRequired: false }
)

const messages = { failedToGetSuppliers: 'Не удалось получить поставщиков.' }

const { $apiHelper, $toast } = useNuxtApp()

const autocompleteSuppliers = ref<AutocompleteItem[]>([])
const debounceForSuppliers = ref<any>(null)
const supplierQuery = ref<string>('')

watch(supplierQuery, (value) => {
  if (!value) {
    autocompleteSuppliers.value = []

    return
  }

  if (debounceForSuppliers.value) {
    clearTimeout(debounceForSuppliers.value)
  }

  debounceForSuppliers.value = setTimeout(() => loadSuppliersData(value), 500)
})
watch(model, (value: SelectedItem | null): void => {
  if (value === null) {
    autocompleteSuppliers.value = []
    debounceForSuppliers.value = null
    supplierQuery.value = ''
  }
})

async function loadSuppliersData (_supplierQuery: string): Promise<any> {
  const params = { 'filter[query]': _supplierQuery, 'page[size]': 50 }

  try {
    const { data } = await $apiHelper.suppliers.getSuppliers(params, AuthScope.Admin)

    if (!_supplierQuery || _supplierQuery === supplierQuery.value) {
      autocompleteSuppliers.value = data.map((x: any): AutocompleteItem => ({ id: x.id, name: x.attributes.name }))
    }
  } catch (error) {
    console.error(error)

    $toast.error(messages.failedToGetSuppliers)
  }
}

function updateSelectedSupplier (x: SelectedItem | null, isAdding: boolean): void {
  model.value = x

  if (isAdding) {
    autocompleteSuppliers.value = []
  }
}
</script>

<template>
  <SingleSelect
    v-model="supplierQuery"
    :autocomplete-items="autocompleteSuppliers"
    :is-required="isRequired"
    label-text="Поставщик"
    placeholder="Введите поставщика"
    :selected-item="model"
    @update-selected-item="updateSelectedSupplier"
  />
</template>
